import { generateFreelancerReputationsObjects } from '../freelancer-reputations/freelancer-reputations.seed';

export const generateFreelancerReputationsRehireRatesObjects = generateFreelancerReputationsObjects;
